import { Injectable } from '@angular/core';
import { CanLoad, Route, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../../user/user.service';

@Injectable()
export class RoleGuardService implements CanActivate {

  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    /* console.log(
      this.userService.info.guest_student_count,
      state.url.startsWith('/exchange-student')
    ); */

    localStorage.setItem("Guest", 'true');
    //if (this.userService.info.guest_student_count) {
    if (this.userService.role === 'exchange') {
      //guest student
      if (!state.url.startsWith('/exchange-student')) {
        this.router.navigate(['/exchange-student'])
        return false;
      }
    } else {
      // normal student
      if (state.url.startsWith('/exchange-student')) {
        this.router.navigate(['']);
        return false;
      }
    }
    return true;
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/services/route-guards/role-guard/role-guard.service.ts